import { useNavigate } from "react-router-dom";
import { Truck } from "lucide-react";
import { useEffect } from "react";
import { useStore } from "../../context/StoreContext";
import { CartLine } from "./CartLine";
import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle } from "../ui/sheet";
import { useCart } from "../../context/CartContext";
import { useLang } from "../../context/LangContext";
import { imgUrl, eur } from "../../lib/api";

export const CartDrawer = () => {
  const { items, open, setOpen, subtotal, validate, notices } = useCart();
  const { t, tr } = useLang();
  const { free_shipping_de = 100 } = useStore();
  const nav = useNavigate();
  const left = Math.max(0, free_shipping_de - subtotal);
  useEffect(() => { if (open) validate().catch(() => {}); }, [open, validate]);

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetContent className="w-full sm:max-w-md p-0 flex flex-col bg-[#F7F5FB] border-l-0 [&>button]:text-white [&>button]:opacity-90 [&>button]:top-6" data-testid="cart-drawer">
        <SheetHeader className="bg-[#120E1F] px-6 py-5 text-left">
          <SheetTitle className="font-display text-2xl text-white">{t("cart")}</SheetTitle>
          <SheetDescription className="sr-only">{t("cart")}</SheetDescription>
        </SheetHeader>
        {items.length > 0 && (
          <div className="px-6 py-4 border-b border-[#120E1F]/5">
            <p className="text-xs text-[#120E1F] flex items-center gap-2"><Truck className="h-4 w-4 text-[#F2C230]" />{left > 0 ? t("free_ship_left", { n: eur(left) }) : t("free_ship_ok")}</p>
            <div className="mt-2 h-1.5 rounded-full bg-[#120E1F]/10 overflow-hidden"><div className="h-full bg-[#F2C230] transition-[width] duration-500" style={{ width: `${Math.min(100, (subtotal / free_shipping_de) * 100)}%` }} /></div>
          </div>
        )}
        <div className="flex-1 overflow-y-auto px-6 py-4 space-y-4">
          {items.length === 0 && <p className="text-center text-[#707783] py-16" data-testid="cart-empty">{t("cart_empty")}</p>}
          {items.map((i) => <CartLine key={i.id} i={i} notice={notices[i.id]} compact />)}
        </div>
        {items.length > 0 && (
          <div className="border-t border-[#120E1F]/10 bg-white px-6 py-5 space-y-4">
            <div className="flex justify-between text-sm"><span>{t("subtotal")}</span><span className="font-mono font-semibold" data-testid="cart-subtotal">{eur(subtotal)}</span></div>
            <p className="text-[11px] text-[#707783]">{tr("inkl. MwSt., zzgl. Versand", "incl. VAT, plus shipping")}</p>
            <button data-testid="cart-view-btn" onClick={() => { setOpen(false); nav("/cart"); }} className="btn-outline w-full">{tr("Warenkorb ansehen", "View cart")}</button>
            <button data-testid="cart-checkout-btn" onClick={() => { setOpen(false); nav("/cart"); }} className="btn-gold w-full">{t("checkout")}</button>
          </div>
        )}
      </SheetContent>
    </Sheet>
  );
};
